import Vue from 'vue'
import Vuex from 'vuex'
import {getUser, saveUserProjectOptions} from '@/helpers/api/user'

Vue.use(Vuex)
const token = localStorage.getItem('userToken')

const store = new Vuex.Store({
	state: {
		userInfo: null,
		isAuthenticated: token ? true:false,
		userCompanies: [],
		selectedCompany: null,
		companyPermissions: null,
		systemRoles: []
	},
	mutations: {
		setUserInfo(state, user){
			state.userInfo = user
			state.isAuthenticated = true
		},
		setIsAuthenticated(state, status){
			state.isAuthenticated = status
		},
		setUserCompanies(state, companies){
			state.userCompanies = companies
		},
		logoutUser(state) {
			state.userInfo = null
			state.isAuthenticated = null
			localStorage.removeItem('userToken')
		},
		setCompanyPermissions(state, permissions){
			state.companyPermissions = permissions
		},
		setSelectedCompany(state, company){
			state.selectedCompany = company
		},
		setSystemRoles(state, roles){
			state.systemRoles = roles
		}
	},
	getters: {
		authState: state => {
			return state.isAuthenticated
		},
		// Nuevo: getter reactivo, se recalcula solo cuando systemRoles cambia.
		// Cualquier componente puede usarlo como computed: this.$store.getters.isSuperAdmin
		isSuperAdmin: state => {
			return state.systemRoles?.map(role => role.system_role_id).includes(1) || false
		}
	},
	actions: {
		async getUserInfo(context){
			const user = await getUser()
			if(user.code == 200){
				context.commit('setUserInfo', user.user)
				context.commit('setUserCompanies', user.user.companies)
				context.commit('setSystemRoles', user.user.system_roles)
			}
		},
		async setUserProjectOptions(context, data){
			await saveUserProjectOptions(data)
			return new Promise((resolve) => {
				resolve(true)
			})
		}
	}
})

// Nuevo: promesa cacheada para saber cuándo terminó la carga inicial del usuario.
// No modifica el store ni sus consumidores actuales; es un helper adicional
// pensado para usarse desde el router (beforeEach) antes de evaluar permisos.
let userLoadPromise = null

export function ensureUserLoaded() {
	// Si no hay token, no hay nada que cargar (usuario no logueado)
	if (!token) return Promise.resolve()

	// Si ya se cargó (por ejemplo tras un login normal en la sesión), no repetir
	if (store.state.userInfo) return Promise.resolve()

	// Cachea la promesa para no disparar getUserInfo más de una vez
	// aunque el guard corra varias veces antes de que resuelva
	if (!userLoadPromise) {
		userLoadPromise = store.dispatch('getUserInfo')
	}

	return userLoadPromise
}

export default store